import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  private apiURL = environment.apiBaseUrl + '/user';

  constructor(private http: HttpClient) { }

  // Metodo per creare una nuova prenotazione
  createPrenotazione(prenotazione: any): Observable<any> {
    return this.http.post(`${this.apiURL}/salva-prenotazione`, prenotazione);
  }

  // Metodo per ottenere gli slot liberi
  getSlotLiberi(id_prestazione: string, data: string): Observable<any> {
    return this.http.post(`${this.apiURL}/get-slot-liberi`, { prestazione: id_prestazione, data: data });
  }
}
